// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_th-0";
export var checkoutRateBadgeLink = "_th-1";